import { 
    // 批量通知列表
    apiBizGetBatchNotifyList,
    // 批量通知設定
    apiBizUpdateBatchNotify,
    // 自動收租設定
    apiBizUpdateSendRent,
    // 自動提醒設定
    apiBizUpdateNotify
    } from "@/apis/api.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_checkbox_status: 'batchNotify/set_checkbox_status',
    set_batch_notify_list: 'batchNotify/set_batch_notify_list',
    set_selected_item: 'batchNotify/set_selected_item',
    set_filter_query: 'batchNotify/set_filter_query',
    set_success_list: 'batchNotify/set_success_list',
}

// count state 必須是 Object
const state = {
    bizBatchNotifyList: [],
    checkboxStatus: {
        checkboxAll: false,
    },
    selectedItem: [],
    filterQuery: {},
    filterQueryUpdate: 0,
    successList: []

}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_BATCH_NOTIFY_LIST: (state) => {
        return state.bizBatchNotifyList
    },
    GET_BIZ_BATCH_NOTIFY_SUCCESS_LIST: (state) => {
        return state.successList
    },
    GET_BIZ_BATCH_NOTIFY_LIST_TOTAL: (state) => {
        return state.bizBatchNotifyList.length
    },
    GET_BIZ_BATCH_NOTIFY_CHECKBOX_STATUS: (state) => {
        return state.checkboxStatus
    },
    GET_BIZ_BATCH_NOTIFY_HAS_SELECTED_HOUSE: (state) => {
        return state.selectedItem.length?true:false
    },
    GET_BIZ_BATCH_NOTIFY_SELECTED_HOUSE_CID: (state) => {
        return state.selectedItem
    },
    GET_BIZ_BATCH_NOTIFY_FILTER_QUERY: (state) => {
        return state.filterQuery
    },
    GET_BIZ_BATCH_NOTIFY_FILTER_QUERY_UPDATE: (state) => {
        return state.filterQueryUpdate
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizBatchNotifyList ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            apiBizGetBatchNotifyList(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let batchNotify = res.data.result
                    commit(types.set_batch_notify_list, batchNotify)
                    commit(types.set_success_list)
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    updateBizSendRent ( {commit, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            apiBizUpdateSendRent(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    // dispatch('getBizBatchNotifyList')
                    commit(types.set_success_list)
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    updateBizNotify ( {commit, dispatch}, data ) {
        return new Promise((resolve, reject) => {
            apiBizUpdateNotify(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    // dispatch('getBizBatchNotifyList')
                    commit(types.set_success_list)
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    updateBizBatchNotify ( {commit, dispatch, getters}, type ) {
        return new Promise((resolve, reject) => {
            let data = {
                type: type,
                contractCidList:  getters.GET_BIZ_BATCH_NOTIFY_SELECTED_HOUSE_CID
            }
            apiBizUpdateBatchNotify(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    dispatch('getBizBatchNotifyList')
                    commit(types.set_success_list)
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    setBizBatchNotifyCheckboxStatus ( {commit}, data ) {
        commit(types.set_checkbox_status, data)
    },
    setBizBatchNotifySeletedHouse ( {commit}, data ) {
        commit(types.set_selected_item, data)
    },
    setBizBatchNotifyFilterQuery ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_query, value);
            resolve()
        })
    },
    setSuccessFlag ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_query, value);
            resolve()
        })
    },
}

// mutations
const mutations = {
    [types.set_checkbox_status](state, data){
        state.checkboxStatus = data
    },
    [types.set_selected_item](state, data){
        state.selectedItem = data
    },
    [types.set_batch_notify_list](state, data){
        state.bizBatchNotifyList = data
    },
    [types.set_filter_query](state, data){
        state.filterQuery = data
        state.filterQueryUpdate += 1
    },
    [types.set_success_list](state, data){
        if(data){
            state.successList = data
        }else{
            state.successList = state.selectedItem
        }
    },
    
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/mgtCategory/leaseMgt/batchNotify.js